import React, { useState, useEffect } from 'react';
import {
  FaSolarPanel,
  FaBolt,
  FaBroadcastTower,
  FaBuilding,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaArrowRight,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaCoins,
  FaLeaf,
  FaBars,
  FaTimes,
  FaWhatsapp,
  FaPhoneAlt,
  FaArrowLeft,
  FaArrowRight as FaArrowRightIcon,
} from 'react-icons/fa';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { MdEmail } from 'react-icons/md';
import HomePng from '../Assets/Images/solarpng-removebg-preview.png';
import HomeBg from '../Assets/Images/HomeBg.jpg';
import HomeBg2 from '../Assets/Images/HomeBg2.jpg';
import HomeBg3 from '../Assets/Images/HomeBg3.jpg';
import HomeBg4 from '../Assets/Images/HomeBg4.jpg';
import HomeBg5 from '../Assets/Images/HomeBg5.jpg';
import GetInTouchBgImage from '../Assets/Images/getInTouch-BgImage.jpg';
import AboutBgImage from '../Assets/Images/AboutBgImage.jpeg';
import Services from './Services';
import Header2 from '../Layouts/Header2';
import Footer from '../Layouts/Footer';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules'; 
import 'swiper/css';
import 'swiper/css/pagination';


const Header = () => {
  
  return (
    <>
      

      
    </>
  );
};

const App = () => {
  const images = [HomeBg, HomeBg2, HomeBg3, HomeBg4, HomeBg5];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [ref, inView] = useInView({ triggerOnce: true });
  const [ref1, inView1] = useInView({ triggerOnce: true });
  const [ref2, inView2] = useInView({ triggerOnce: true });

  const galleryImages = [
    {
      src: 'https://static.vecteezy.com/system/resources/thumbnails/054/707/291/small_2x/male-technicians-with-a-project-plan-on-a-solar-farm-three-workers-in-protective-uniform-and-helmets-discussing-about-solar-panels-installation-in-a-bright-day-video.jpg',
      alt: 'Technicians discussing solar panel installation',
    },
    {
      src: 'https://images.indianexpress.com/2017/11/pune-pmc-felling-trees-759.jpg?w=414',
      alt: 'Environmental context',
    },
    {
      src: 'https://www.solarpowerworldonline.com/wp-content/uploads/2019/10/petersendean-solar-install.jpg',
      alt: 'Solar panel equipment',
    },
    {
      src: 'https://5.imimg.com/data5/DO/JN/UP/SELLER-77718873/solar-power-plant-grid-tied-30-subsidized-along-with-excess-export-incentives-delhi-500x500.jpg',
      alt: 'Grid-tied solar power plant',
    },
    {
      src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPYM3Hmj0J7H2EaIrGdf9z1-W818KFE38hPQ2rJMuaTnOpUWKxOBdmSL5gVitlApuSrgk&usqp=CAU',
      alt: 'Solar installation overview',
    },
    {
      src: 'https://www.apslaw.com/wp-content/uploads/2015/08/Forbes-Street-Solar-Case-Study.jpg',
      alt: 'Solar project case study',
    },
  ];

  useEffect(() => {
    const imageInterval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => {
      clearInterval(imageInterval);
    };
  }, [images]);

  const slides = [
    {
      title: 'Our Group of Companies',
      content: (
        <ul className="list-disc list-inside space-y-1 text-gray-700 font-semibold">
          <li className='font-semibold'>Madura Building</li>
          <li className='font-semibold'>Sri Sivasiva Sands and Stones</li>
          <li className='font-semibold'>HSP Polymer</li>
          <li className='font-semibold'>Madura Agro and Food Products</li>
          <li className='font-semibold'>Madura Moduen Rice Mill</li>
          <li className='font-semibold'>Dhaj Sands and Stones</li>
          <li className='font-semibold'>Solar More</li>
        </ul>
      ),
      image: 'https://www.shutterstock.com/shutterstock/videos/1085706956/thumb/1.jpg?ip=x480',
    },
    {
      title: 'Our Vision',
      content: (
        <p className="text-base text-gray-600 font-medium leading-relaxed">
         Our vision is to be a global leader in the renewable energy sector, recognized for our excellence in solar procurement, installation, and sustainable energy solutions. We aspire to drive the transition towards a greener, more sustainable future by providing innovative, reliable, and cost-effective solar technologies.

We are committed to empowering communities, industries, and businesses worldwide by making clean energy accessible to all. Through continuous innovation, strategic partnerships, and unwavering dedication to quality, we aim to play a pivotal role in combating climate change and securing a healthier planet for future generations.
        </p>
      ),
      image: 'https://www.webelsolar.com/frontend/images/vis-pic.jpg',
    },
    {
      title: 'Our Mission',
      content: (
        <p className="text-base text-gray-600 font-medium leading-relaxed">
          Our mission is to deliver exceptional solar energy solutions by combining advanced engineering, meticulous procurement, and expert construction practices. We are dedicated to providing our clients with high-performance, sustainable energy systems that maximize efficiency, reduce environmental impact, and generate long-term value.

Through innovation, integrity, and a commitment to excellence, we strive to support individuals, businesses, and communities in their transition to clean, renewable energy. Our focus is on building trust, fostering lasting partnerships, and contributing meaningfully to a sustainable future.
        </p>
      ),
      image: 'https://img.canarymedia.com/content/uploads/enn/2023-06-IMGL9359.jpg?auto=compress%2Cformat&crop=focalpoint&fit=crop&fp-x=0.3947&fp-y=0.3015&h=501&q=80&w=864&s=6a4cafab2a7aa68d0cd06b2c566f4e64',
    },
  ];

  return (

    <>

    <div className="fixed right-1 top-1/2 -translate-y-1/2 flex flex-col space-y-6 bg-white border-2 border-black z-[1000] rounded-full p-3 shadow-lg">
        <div className="relative group flex items-center">
          <a
            href="https://wa.me/9047010004"
            target="_blank"
            rel="noopener noreferrer"
            className="text-green-500 hover:text-[#70962f] text-xl transform hover:scale-110 transition-transform"
          >
            <FaWhatsapp />
          </a>
          <span className="absolute right-full mr-2 whitespace-nowrap bg-green-500 text-white text-sm rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            Chat On WhatsApp
          </span>
        </div>
        <div className="relative group flex items-center">
          <a
            href="https://mail.google.com/mail/?view=cm&to=info@solarmoresolutionns.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:text-blue-600 text-xl transform hover:scale-110 transition-transform"
          >
            <MdEmail />
          </a>
          <span className="absolute right-full mr-2 whitespace-nowrap bg-blue-500 text-white text-sm rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            Contact via Email
          </span>
        </div>
        <div className="relative group flex items-center">
          <a
            href="tel:+1234567890"
            className="text-red-500 hover:text-red-600 text-xl transform hover:scale-110 transition-transform"
          >
            <FaPhoneAlt />
          </a>
          <span className="absolute right-full mr-2 whitespace-nowrap bg-red-500 text-white text-sm rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            Contact via Phone
          </span>
        </div>
      </div>

    <div className="min-h-screen bg-gradient-to-b from-white to-blue-50 font-sans">
      <Header />
      <Header2/>


      <section id="home" className="relative py-20 overflow-hidden">
        <div className="absolute inset-0 z-0">
          {images.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-transform duration-1000 ease-in-out ${index === currentImageIndex
                  ? 'transform translate-x-0'
                  : index < currentImageIndex
                    ? 'transform -translate-x-full'
                    : 'transform translate-x-full'
                }`}
              style={{
                backgroundImage: `url(${image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                opacity: 0.8,
              }}
            ></div>
          ))}
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/80 to-transparent z-0"></div>
        <div className="container mx-auto px-4 relative z-10 mt-[90px]">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="max-w-2xl md:w-1/2 animate-slideInFromLeft">
              <div className="relative mb-4">
                <div className="absolute -left-4 top-0 w-1 h-12 bg-[#70962f]"></div>
                <h4 className="text-[#70962f] font-semibold mb-2 animate-slideInLeft">
                  RENEWABLE ENERGY SOLUTIONS
                </h4>
                <h1 className="text-4xl md:text-6xl font-bold text-[#70962f] mb-6 leading-tight animate-slideInLeft">
                  Powering a <span className="text-[#70962f]">Sustainable</span> Future
                </h1>
              </div>
              <p className="text-md md:text-md font-semibold text-gray-800 mb-8 animate-slideInLeft">
                Solarmore Solutions Green Energy Private Limited, incorporated in 2014,  is a pioneering company in
                the renewable energy sector, specializing in the procurement of premium solar components and the installation of state-of-the-art solar power plants. With a strong commitment to sustainability, technological advancement, and client satisfaction, Sturja is
                positioned as a trusted partner in the solar energy industry. Currently, Struja is engaged
                in a 15-megawatt project, with ambitious plans to scale up to 100 megawatts by 2025,
                catering to a diverse clientele across residential, commercial, and industrial sectors.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 animate-slideInLeft">
                <button className="bg-[#70962f] text-white px-6 py-2 rounded-full flex items-center justify-center group">
                  <a href="#services">Discover Our Solutions</a>
                  <FaArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
                </button>
                <button className="border-2 border-green-700 text-[#70962f] hover:bg-green-50 px-6 py-2 rounded-full flex items-center justify-center">
                  <a href="#contact">Contact Us</a>
                </button>
              </div>
              <div ref={ref} className="grid grid-cols-3 gap-6 mt-12 animate-slideInLeft">
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#70962f] mb-1">
                    11+
                  </div>
                  <div className="text-sm text-gray-600">Years Experience</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#70962f] mb-1">
                    110+
                  </div>
                  <div className="text-sm text-gray-600">Projects Done</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#70962f] mb-1">
                    99.9%
                  </div>
                  <div className="text-sm text-gray-600">Satisfaction</div>
                </div>
              </div>
            </div>
            <div className="md:w-1/2 mt-8 md:mt-0 flex justify-center items-center">
              <div className="relative">
                <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-blue-200 rounded-full opacity-50 animate-pulse"></div>
                <img
                  src={HomePng}
                  alt="Solar Energy Solutions"
                  className="rounded-2xl shadow-2xl relative z-10 transform hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

       <section id="about" className="py-12 bg-gradient-to-b from-white to-green-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-4xl font-bold text-[#70962f] mb-4">About Our Company</h2>
          <div className="w-24 h-1 bg-[#70962f] mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-semibold">
            SolarMore Solution is a proud sister concern of the esteemed Madura Group of Companies...
          </p>
        </div>

<div className=''>
        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          spaceBetween={30}
          slidesPerView={1}
          loop={true}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                <div className="bg-white rounded-xl shadow-lg p-6">
                  <h3 className="text-2xl font-bold text-[#70962f] mb-4">{slide.title}</h3>
                  {slide.content}
                </div>
                <div className="rounded-lg overflow-hidden shadow-xl">
                  <img
                    src={slide.image}
                    alt={slide.title}
                    className="w-full h-auto object-cover"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        </div>


      </div>
    </section>

      <Services />

      <section
        id="gallery"
        className="py-12 bg-center bg-no-repeat bg-cover relative"
        style={{
          backgroundImage: "url('https://thumbcdn.123freevectors.com/wp-content/resized/168982-green-and-grey-background-texture.jpg')",
        }}
      >
        <div className="absolute inset-0 bg-white opacity-50 z-0"></div> {/* Optional white overlay */}
        <div className="relative z-10 container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-[#70962f] mb-10">Our Deployed Sites</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {galleryImages.map((image, index) => (
              <div
                key={index}
                className="relative overflow-hidden rounded-lg shadow-lg group"
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-opacity duration-300 flex items-center justify-center">
                  <p className="text-white text-center text-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    {image.alt}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      <section
        id="contact"
        className="py-16 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${GetInTouchBgImage})` }}
      >
        <div className="bg-[#ffffffd4] mx-4 p-4 py-8 shadow-lg rounded-2xl">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-[#70962f] text-center mb-4">Get In Touch</h2>
            <div className="w-24 h-1 bg-[#70962f] mx-auto mb-12"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
              <div>
                <h3 className="text-2xl font-semibold text-[#70962f] mb-6">Contact Information</h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <FaMapMarkerAlt className="text-xl text-[#70962f] mt-1 mr-4" />
                    <div>
                      <p className="text-lg text-gray-800 font-bold">Headquarters</p>
                      <p className="text-gray-700 font-semibold">
                        1A, Plot No: 28, Karpaganagar Main Street, Ganapathy Nagar, Madurai South, Madurai - 625012.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <FaPhone className="text-xl text-[#70962f] mt-1 mr-4" />
                    <div>
                      <p className="text-lg font-bold text-gray-800">Phone</p>
                      <p className="text-gray-700 font-semibold">+91 9994223604 / 9047010004</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <FaEnvelope className="text-xl text-[#70962f] mt-1 mr-4" />
                    <div>
                      <p className="text-lg font-bold text-gray-800">Email</p>
                      <p className="text-gray-700 font-semibold">info@solarmore.com / md@solarmore.com</p>
                    </div>
                  </div>
                </div>
                <div className="mt-8">
                  <h3 className="text-xl font-semibold text-[#70962f] mb-4">Follow Us</h3>
                  <div className="flex space-x-4">
                    <a
                      href="#"
                      className="w-10 h-10 rounded-full bg-[#70962f] flex items-center justify-center text-white hover:bg-[#70962f] transition-colors"
                    >
                      <FaFacebookF />
                    </a>
                    <a
                      href="#"
                      className="w-10 h-10 rounded-full bg-[#70962f] flex items-center justify-center text-white hover:bg-[#70962f] transition-colors"
                    >
                      <FaTwitter />
                    </a>
                    <a
                      href="#"
                      className="w-10 h-10 rounded-full bg-[#70962f] flex items-center justify-center text-white hover:bg-[#70962f] transition-colors"
                    >
                      <FaLinkedinIn />
                    </a>
                    <a
                      href="#"
                      className="w-10 h-10 rounded-full bg-[#70962f] flex items-center justify-center text-white hover:bg-[#70962f] transition-colors"
                    >
                      <FaInstagram />
                    </a>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-lg border border-gray-200 p-8">
                <h3 className="text-2xl font-semibold text-[#70962f] mb-6">Send Us a Message</h3>
                <div className="space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-gray-700 mb-2">First Name</label>
                      <input
                        type="text"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                      />
                    </div>
                    <div>
                      <label className="block text-gray-700 mb-2">Last Name</label>
                      <input
                        type="text"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-gray-700 mb-2">Email</label>
                    <input
                      type="email"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 mb-2">Phone</label>
                    <input
                      type="tel"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 mb-2">Message</label>
                    <textarea
                      rows={4}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                    ></textarea>
                  </div>
                  <button className="bg-[#70962f] hover:bg-green-800 text-white px-6 py-2 rounded-full">
                    Send Message
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      

      <Footer/>

    </div>

    </>
  );
};

export default App;